/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    checked: {
      description: 'Corresponds to a selected state for a checkbox or radio',
      type: 'state',
      values: [ true ]
    },
    error: { type: 'state', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { error: true },
      tokens: {
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#ffffff',
        inputOutlineColor: '#000000',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderWidth: 0
      }
    },
    {
      if: { focus: true },
      tokens: {
        outerBorderColor: '#000000',
        outerBorderGap: 2,
        outerBorderWidth: 1
      }
    },
    { if: { hover: true }, tokens: { outerBorderColor: '#000000' } },
    {
      if: { inactive: true },
      tokens: {
        inputBackgroundColor: '#c9c8c8',
        inputBorderColor: '#c9c8c8',
        inputOutlineColor: '#c9c8c8',
        labelColor: '#666666',
        outerBorderGap: 0
      }
    },
    {
      if: { checked: true, inactive: true },
      tokens: {
        checkedBackgroundColor: '#c9c8c8',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#efefef',
        inputBorderWidth: 3,
        inputOutlineColor: '#c9c8c8',
        inputOutlineWidth: 1,
        labelColor: '#666666',
        outerBorderColor: '#c9c8c8'
      }
    }
  ],
  tokens: {
    checkedBackgroundColor: '#7a3dfc',
    checkedSize: 12,
    containerBackgroundColor: 'rgba(0, 0, 0, 0)',
    containerBorderRadius: 0,
    containerOpacity: 1,
    containerPaddingBottom: 0,
    containerPaddingLeft: 0,
    containerPaddingRight: 0,
    containerPaddingTop: 0,
    containerShadow: null,
    descriptionFontName: 'StagSans',
    descriptionFontSize: 14,
    descriptionFontWeight: '400',
    descriptionLineHeight: 1.4,
    descriptionMarginLeft: null,
    icon: null,
    iconBackgroundColor: 'rgba(0, 0, 0, 0)',
    iconColor: 'rgba(0, 0, 0, 0)',
    inputBackgroundColor: '#ffffff',
    inputBorderColor: '#000000',
    inputBorderWidth: 1,
    inputOutlineColor: '#000000',
    inputOutlineWidth: 1,
    inputSize: 20,
    labelColor: '#000000',
    labelFontName: 'StagSans',
    labelFontSize: 16,
    labelFontWeight: '400',
    labelLineHeight: 1.5,
    labelMarginLeft: 8,
    outerBorderColor: 'transparent',
    outerBorderGap: 1,
    outerBorderWidth: 1
  }
}
export default theme
